export const EMPTY_FILTERS = 'filters/EMPTY_FILTERS';
export const SET_FILTERS = 'filters/SET_FILTERS';
